import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {useQuery} from "../utils/function-util";
import {WithOrganization} from "../components/organizations/organization-context";
import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {GoBackButton} from "../components/ui/GoBackButton";
import ReactsCard from "../components/ui/ReactsCard";
import {MoveMembersWizard} from "../components/members/move-members/MoveMembersWizard";

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(4),
        '& > *': {
            'margin-bottom': theme.spacing(4)
        }
    }
}));

export const MoveMembersView: React.FC<WithOrganization> = ({currentOrganization}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const classes = useStyles();
    const query = useQuery();
    const returnUrl = query.get('returnUrl');

    const goBack = () => {
        navigate(returnUrl ? returnUrl : '/members');
    }

    const getTitle =
        <Fragment>
            <GoBackButton goBack={goBack}/>
            {t('Members.MoveMembers.Title')}
        </Fragment>;

    return (
        <div className={classes.root}>
            <ReactsCard title={getTitle}>
                <MoveMembersWizard goBack={goBack} organizationId={currentOrganization.id}/>
            </ReactsCard>
        </div>)
}
